module.exports = __webpack_public_path__ + "img/index7.ab8097e0.jpg";